export default {
  AddNew: 'addnew',
  Print: 'print',
  Delete: 'delete',
  Save: 'save',
  Cancel: 'cancel',
  PageCancel: 'pageCancel',
  ToggleSide: 'toggleside',
  Lock: 'lock',
  PriceParts: 'priceparts',
  ApplyQuoteTemplate: 'applyquotetemplate',
  Calendar: 'calendar',
  Convert: 'convert',
  NewAdditionalQuote: 'newAdditionalQuote',
  CopyQuote: 'copyQuote',
  ExportQuote: 'exportQuote',
  ViewCreditorStatement: 'viewCreditorStatement',
  ViewDebtorStatement: 'viewDebtorStatement',
  ViewAdvancePaymentEntry: 'viewAdvancePaymentEntry',
  ViewAdvanceReceiptEntry: 'viewAdvanceReceiptEntry',
  FactorInvoice: 'factorInvoice',
  FactorSelectedInvoice: 'factorSelectedInvoice',
  ViewBankUnDepositedFunds: 'viewBankUnDepositedFunds',
  Restore: 'restore',
  EnableAssessmentHistory: 'enableAssessmentHistory'
}
